__turbopack_context__.v({
  "card": "m-e-auto-tariff-card-module-scss-module__DBrw0q__card",
  "footer": "m-e-auto-tariff-card-module-scss-module__DBrw0q__footer",
  "header": "m-e-auto-tariff-card-module-scss-module__DBrw0q__header",
  "icon": "m-e-auto-tariff-card-module-scss-module__DBrw0q__icon",
  "list": "m-e-auto-tariff-card-module-scss-module__DBrw0q__list",
  "placeholder": "m-e-auto-tariff-card-module-scss-module__DBrw0q__placeholder",
  "subheadline": "m-e-auto-tariff-card-module-scss-module__DBrw0q__subheadline",
  "switch-button": "m-e-auto-tariff-card-module-scss-module__DBrw0q__switch-button",
  "switch-button-active": "m-e-auto-tariff-card-module-scss-module__DBrw0q__switch-button-active",
  "switch-input": "m-e-auto-tariff-card-module-scss-module__DBrw0q__switch-input",
  "switch-input-right-active": "m-e-auto-tariff-card-module-scss-module__DBrw0q__switch-input-right-active",
  "switch-wrapper": "m-e-auto-tariff-card-module-scss-module__DBrw0q__switch-wrapper",
});
